export const roundOfToTwoDigits = (value: number): string => {
  if (value < 10) {
    return `0${value}`
  }
  return value?.toString()
}

export const roundOfToTwoDigits2 = (value1: number): string => {
  const value = ++value1
  if (value < 10) {
    return `0${value}`
  }
  return value?.toString()
}

export const compareNumberArray = (first: Array<number> = [], second: Array<number> = []): boolean =>
  first.length === second.length && first.every((e) => second.includes(e))

export const padZero = (s: number) => {
  return ('0' + s).slice(-2)
}

export const isNumber = (val: any) => {
  return parseFloat(val).toString() === val.toString()
}

export const currencyConvert = (amount: string) => {
  return Number(amount.replace(/[^0-9.-]+/g, ''))
}

export const numberToLocalString = (num: number): string => {
  const formatter = new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 2,
  })
  let numString = formatter.format(num)
  if (numString.slice(-2) === '00') {
    return numString.slice(0, -3)
  }
  return formatter.format(num)
}

export const getRandomNumber = (min: number, max: number): string => {
  return `${Math.floor(Math.random() * (max - min) + min)}`
}
